// extracted by mini-css-extract-plugin
export default {"root_image_inner":"colorsForm_root_image_inner__fQytX"};